module.exports = __webpack_public_path__ + "img/LogoFooter3.f8235266.svg";